const unblockingToast = (state = null, action) => {
  if (action.type === "SET_UNBLOCKING_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_UNBLOCKING_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default unblockingToast;
